import React from 'react'

import type { BaseChartProps } from '../../types'
import { ChartFactory } from '../ChartFactory/ChartFactory'

export const LineChart = (props: BaseChartProps) => {
  return <ChartFactory {...props} chartType="line" />
}
